
import React from 'react';
import { apiGet, getHostApi } from "../../../store/apiWrapper";
import { bindActionCreators } from 'redux';
import { Circles } from '../../common/loadingComponent';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Formik, Form } from 'formik';
import { isNullOrUndefined } from '../../../store/storeFunctions';
import { windowActions } from '../../../store/windowStore';
import { withLocalize, Translate } from 'react-localize-redux';
import { withRouter } from "react-router"
import BbInput from '../../styling/bbInput';
import classnames from 'classnames';
import IndustryAnalysisMethodology from './industryAnalysisMethodology.jsx';
import NoDataComponent from '../../common/noDataComponent';
import SearchTip from '../../common/searchTip';
import SelectOption from '../../searchSections/selectOption';
import TabLink from '../tabLink';

import IconBranches from '../../../img/icons/BBiconsStredniHodnotyOdvetvi';
import IconMethodology from '../../../img/icons/BBiconsMetodika';
import FormMenuControl from '../../common/formMenuControl'

const searchTypes = {
    branch: "branch",
    methodology: "methodology"
};
const emptyYear = undefined;
const isNaceYear = 2008;
const noStructuralReportYear = 2014;

class IndustryAnalysisSearchForm extends React.Component {
    years = [];
    pointers = []
    naces = [];

    state = {
        selected: searchTypes.branch,
        selectedYear: emptyYear,
        isLoading: false
    }

    render() {
        return (
            <div className="content-root content-root-wide">
                <div className="columns is-desktop">
                    <div className="column is-4-desktop tabs tabs-form-menu" style={{ fontSize: "1em" }}>
                        <FormMenuControl>
                            <ul>
                                <TabLink type={searchTypes.branch} selected={this.state.selected} onSelect={this.selectSearch} icon={<IconBranches className="tabs-icon" />}
                                    titleKey='IndustryAnalysis.Branches' descriptionKey='IndustryAnalysis.Branches.Description' hr={true} />

                                <TabLink type={searchTypes.methodology} selected={this.state.selected} onSelect={this.selectSearch} icon={<IconMethodology className="tabs-icon" />}
                                    titleKey='IndustryAnalysis.Methodology' descriptionKey='IndustryAnalysis.Methodology.Description' hr={false} />
                            </ul>
                        </FormMenuControl>
                    </div>
                    <div className='column'>
                        {this.hasSearchTips(this.state.selected) &&
                            <SearchTip windowId={`tips_industry_analysis_${this.state.selected}`} getSearchTipsModel={() => this.getSearchTipsModel(this.state.selected)} className="hide-on-mobile" style={{ marginBottom: '-0.5em', marginTop: '1em' }} />}
                        <div className='card card-special'>
                            {this.hasSearchTips(this.state.selected) &&
                                <SearchTip windowId={`tips_industry_analysis_${this.state.selected}`} getSearchTipsModel={() => this.getSearchTipsModel(this.state.selected)} className="hide-on-desktop" style={{ marginBottom: '-2.5em', paddingTop: '1em', marginRight: '1em' }} />}
                            <div className='card-body'>
                                {this.renderForms()}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    renderForms = () => {
        if (this.state.isLoading)
            return <Circles />

        if (isNullOrUndefined(this.state.selectedYear))
            return (<NoDataComponent />);

        const isNace = (this.state.selectedYear > isNaceYear);

        return (
            <>
                <div className="columns">
                    <div className="column is-4">
                        <BbInput type='select-noformik' label={this.props.translate('IndustryAnalysis.Year')} placeholder={{ type: 'column' }}
                            formatOptionLabel={SelectOption}
                            value={(this.years.find(op => {
                                return op.value === this.state.selectedYear
                            }) || {})}
                            options={this.years}
                            onChange={(e) => {
                                this.setState({ selectedYear: e.value }, () => { this.getData(e.value); });
                            }}
                        />
                    </div>
                    <div className="column is-10"></div>
                </div>
                <hr />
                {this.state.selected === searchTypes.branch && this.renderBranchForm(isNace)}
                {this.state.selected === searchTypes.methodology && this.renderMethodologyForm(isNace)}
            </>
        );
    }

    renderBranchForm = (isNace) => {
        return (
            <Formik
                ref={(el) => this.formRef = el}
                enableReinitialize={true}
                validateOnChange={false}
                validateOnBlur={false}
                initialValues={{
                    selectedPointer: "financialRatios",
                    selectedNace: '01'
                }}
                onSubmit={(values, { setSubmitting }) => {
                    setSubmitting(false);
                    this.submitSearch(searchTypes.branch, values)
                }}
            >
                {({ values, setFieldValue }) => (
                    <Form >
                        <div className="columns">
                            <div className="column is-12">
                                <div className={classnames({ "inactive-input-font-color": !(this.state.selectedYear < noStructuralReportYear) })}>
                                    <BbInput type='select-noformik' label={this.props.translate('IndustryAnalysis.Pointers')} placeholder={{ type: 'jumping' }}
                                        formatOptionLabel={SelectOption}
                                        value={(this.pointers.find(op => {
                                            return op.value === values["selectedPointer"]
                                        }) || {})}
                                        options={this.pointers}
                                        onChange={(e) => setFieldValue("selectedPointer", e.value)}
                                        isDisabled={!(this.state.selectedYear < noStructuralReportYear)}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="columns">
                            <div className="column is-12">
                                <BbInput type='select-noformik'
                                    label={(isNace) ? this.props.translate('IndustryAnalysis.NACE') : this.props.translate('IndustryAnalysis.OKEC')}
                                    placeholder={{ type: 'jumping' }}
                                    formatOptionLabel={SelectOption}
                                    value={(this.naces.find(op => {
                                        return op.value === values["selectedNace"]
                                    }) || {})}
                                    options={this.naces}
                                    onChange={(e) => setFieldValue("selectedNace", e.value)}
                                />
                            </div>
                        </div>
                        <div className='columns m-0 is-centered has-text-centered'>
                            <div className='column is-narrow'>
                                <button className={classnames('bb-button is-primary gradient-1', { 'is-square': localStorage.locales_button_style === 'square' })}
                                    type='submit'
                                    style={{ fontWeight: 600 }}
                                    disabled={this.props.isSearching}
                                >
                                    {this.props.isSearching ? <FontAwesomeIcon icon="cog" spin /> : <Translate id='Search.Common.Search' />}
                                </button>
                            </div>
                        </div>
                    </Form>
                )}
            </Formik>
        );
    }

    renderMethodologyForm = (isNace) => {
        return (
            <div className="columns">
                <div className="column is-12">
                    <IndustryAnalysisMethodology year={this.state.selectedYear} isNace={isNace} />
                </div>
            </div>
        );
    }

    selectSearch = (selected) => {
        if (selected !== this.state.selected) {
            this.setState({ selected: selected });
            this.props.closeAll();
        }
    }

    submitSearch(searchType, values) {
        if ((searchType === searchTypes.branch) && (this.state.selectedYear !== "" && values.selectedPointer !== "" && values.selectedNace !== "")) {
            this.props.history.push(`/search/industry-analysis/results/${this.state.selectedYear}/${values.selectedPointer}/${values.selectedNace}`);
        }
    }

    componentDidMount() {
        this.getData(this.state.selectedYear);
    }

    componentDidUpdate(prevProps) {
        if (this.props.user.language !== prevProps.user.language) {
            this.getData(this.state.selectedYear);
        }
    }

    getData(year) {
        this.setState({ isLoading: true });

        apiGet(`${getHostApi()}/api/industry-analysis/dropdowns`, { year: year },
            (response) => this.onSuccess(response.data),
            () => this.onError()
        );
    }

    onSuccess(data) {
        this.years = data.years.map(year => ({ label: year, value: year }));
        this.pointers = [{ value: "financialRatios", label: this.props.translate("IndustryAnalysis.FinancialRatios") }];
        this.naces = data.naces.map(nace => new NaceItem(nace.code, nace.name));

        this.setState({
            isLoading: false,
            selectedYear: isNullOrUndefined(this.state.selectedYear) ? data.selectedYear : this.state.selectedYear
        },
            () => {
                // HACK from old MC: Disable Industry Structural Ratios for 2014 and later as there are no data according to BU (#295770); update #346724: later years should be disabled too
                if (this.state.selectedYear < noStructuralReportYear) {
                    this.pointers.push({ value: "structuralIndicators", label: this.props.translate("IndustryAnalysis.StructuralIndicators") });
                }
            }
        )
    }

    onError() {
        this.setState({ isLoading: false });
    }

    hasSearchTips(searchType) {
        switch (searchType) {
            case searchTypes.branch:
            case searchTypes.methodology:
                return true;
        }
        return false;
    }

    getSearchTipsModel = (searchType) => {
        switch (searchType) {
            case searchTypes.branch:
                return { title: `${this.props.translate('IndustryAnalysis.Branches')}`, bodyHtml: this.props.translate('SearchTips.IndustryAnalysis.Branch.Body') };
            case searchTypes.methodology:
                return { title: `${this.props.translate('IndustryAnalysis.Methodology')}`, bodyHtml: this.props.translate('SearchTips.IndustryAnalysis.Methodology.Body') };
        }
        return undefined;
    }
}

class NaceItem {
    constructor(code, label) {
        this.value = this.removeDots(code);
        this.label = `${code} - ${label}`;
        this.description = label.trim();
    }

    removeDots(text) {
        return text.split('.').join('');
    }

    // removeNumberPart(text) {
    //     const splitText = text.split('-');
    //     return splitText[1] ? splitText[1].trim() : "";
    // }
}

export default withRouter(withLocalize(connect(null,
    dispatch => bindActionCreators({ ...windowActions }, dispatch))(IndustryAnalysisSearchForm)));
